/**
 * Doc ids have to be strings, non-empty, and free of slashes. Team names are none of those.
 *
 * Shared with `functions/` so a server-side write lands on the document the app reads.
 */
export const docId = (s: string): string => s.trim().replace(/\//g, '∕') || '-';
